import { FundData } from '../../../../api/apis/TrustFamilyApi';
import { DataTable } from '../../../../components';

interface LineupProps {
  editing?: boolean;
  data: FundData[];
  remove?: (row: FundData) => Promise<void>;
  backgroundColor?: string;
}

const LineupTable: React.FC<LineupProps> = props => {
  const { editing, data, remove, backgroundColor } = props;
  const headers = [
    {
      title: 'Ticker',
      label: 'ticker',
    },
    {
      title: 'Investment Name',
      label: 'name',
    },
  ];

  return (
    <DataTable
      headers={headers}
      backgroundColor={backgroundColor}
      data={data.map(security => ({
        id: security.ticker,
        deletableRow: editing ? true : false,
        ticker: security.ticker,
        name: security.name,
      }))}
      emptyStateText={`You haven't added any investments yet.`}
      onDelete={remove}
    />
  );
};

export default LineupTable;
